import { computed, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { GenderType } from 'app/features/contest/models/gender';
import {
  LEADERBOARD_METRIC_OPTIONS,
  LeaderboardMetricId,
  LeaderboardMetricOption,
  TemplateMetricConfig,
  TemplateType,
} from 'app/features/contest/models/contest-template.models';
import { defaultTemplate } from 'app/features/contest/models/templates/default-template';
import { DataUserInfo, TrackInfo } from 'app/features/contest/models/contest-user-info.models';
import { templateControlColorFrom, TemplateControlColor } from '../utils/template-color.utils';

@Injectable()
export class ContestStore {
  username: WritableSignal<string> = signal<string>('');
  hashid: WritableSignal<string> = signal<string>('');
  pprFilter: WritableSignal<number> = signal<number>(3);
  targetGender: WritableSignal<GenderType> = signal<GenderType>('');

  template: WritableSignal<TemplateType> = signal<TemplateType>(defaultTemplate);
  templateMetrics: Signal<TemplateMetricConfig> = computed(() => this.template().metrics);
  metricOptions: Signal<LeaderboardMetricOption[]> = computed(() => {
    const availableMetricIds: Set<LeaderboardMetricId> = new Set<LeaderboardMetricId>(
      this.templateMetrics().available
    );

    return LEADERBOARD_METRIC_OPTIONS.filter((option: LeaderboardMetricOption) =>
      availableMetricIds.has(option.id)
    );
  });
  templateControlColor: Signal<TemplateControlColor> = computed(() =>
    templateControlColorFrom(this.template().theme.textColor)
  );
  secondaryControlColor: Signal<TemplateControlColor> = computed(() =>
    templateControlColorFrom(this.template().theme.secondaryColor)
  );
  trackInfo: WritableSignal<TrackInfo | null> = signal<TrackInfo | null>(null);
  userInfo: WritableSignal<DataUserInfo | null> = signal<DataUserInfo | null>(null);
}
